import { render, staticRenderFns } from "./login-new.vue?vue&type=template&id=3d8bf2f2&scoped=true"
import script from "./login-new.vue?vue&type=script&lang=js"
export * from "./login-new.vue?vue&type=script&lang=js"
import style0 from "./login-new.vue?vue&type=style&index=0&id=3d8bf2f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8bf2f2",
  null
  
)

export default component.exports